import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[fontWeight],[fontSize],[color],[iconSize],[width],[height]'
})
export class CssDirective implements OnChanges {

  @Input() fontSize: string;
  @Input() fontWeight: string;
  @Input() color: string;
  @Input() iconSize: string;
  @Input() height: string;
  @Input() width: string;
  constructor(private eleRef: ElementRef) {}

  ngOnChanges(): void {
    if (this.fontSize) {
      this.eleRef.nativeElement.style.fontSize = this.fontSize;
    }
    if (this.fontWeight) {
      this.eleRef.nativeElement.style.fontWeight = this.fontWeight;
    }
    if (this.color) {
      this.eleRef.nativeElement.style.color = this.color;
    }
    
    
    if (this.height) {
      this.eleRef.nativeElement.style.height = this.height;
    }
    if (this.width) {
      this.eleRef.nativeElement.style.width = this.width;
    }
    if (this.iconSize) {
      this.eleRef.nativeElement.style.fontSize = this.iconSize;
      this.eleRef.nativeElement.style.height = this.iconSize;
      this.eleRef.nativeElement.style.width = this.iconSize;
    }
  }
}
